import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import validate from './validate';
import InvestmentsDetailTable from './InvestmentsTable'
import { renderField } from '../../../../../Utils/renderField/renderField';

let InvestmentsForm = props => {
    const { handleSubmit, item } = props;

    return (
        <form onSubmit={handleSubmit}>
            <div className='col-sm-12 p-0'>
                    <div className="col-12 p-0 mt-2">
                        <div className='d-flex flex-wrap'>
                            <div className='mr-md-4 col-12 col-md-6 col-lg-4 p-0'>
                                <label htmlFor="name" className="m-0">Nombre de la inversión</label>
                                <div className="form-group">
                                    <Field
                                        id='name'
                                        name="name"
                                        component={renderField}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <InvestmentsDetailTable {...props} dollar_exchange={item} />
                <div className='buttons-box mt-4 mb-4'>
                    <Link 
                        className="btn btn-outline-dark btn-modal mr-3 mb-3"
                        type="button"
                        to="/inversiones/summary">
                        REGRESAR
                    </Link>
                    <button 
                        type="submit" 
                        className="btn btn-primary btn-modal mr-3 mb-3">
                        CONFIRMAR
                    </button>
                </div>
            </div>
        </form>
    );
};

InvestmentsForm = reduxForm({
    form: 'InvestmentsForm',
    validate,
})(InvestmentsForm);

export default InvestmentsForm;
